// Imported from the focused package, not the `@aws-sdk/credential-providers` umbrella — the
// umbrella re-exports Node-only providers (e.g. the login/builder-ID flow) that reference
// `node:fs`/`node:crypto` in ways Vite's browser build can't shim, breaking the bundle.
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { CognitoIdentityClient, GetIdCommand } from '@aws-sdk/client-cognito-identity';
import { config } from './config';

let currentIdToken: string | null = null;
let currentIdentityId: string | null = null;
let identityPromise: Promise<string | null> | null = null;

const loginsKey = `cognito-idp.${config.awsRegion}.amazonaws.com/${config.userPoolId}`;

export function setIdToken(token: string | null): void {
  if (token !== currentIdToken) {
    currentIdToken = token;
    currentIdentityId = null;
    identityPromise = null;
  }
}

export function getIdToken(): string | null {
  return currentIdToken;
}

export async function ensureIdentityId(): Promise<string> {
  if (currentIdentityId) return currentIdentityId;
  if (!currentIdToken) throw new Error('Not signed in.');
  if (!identityPromise) {
    identityPromise = (async () => {
      const cognito = new CognitoIdentityClient({ region: config.awsRegion });
      const r = await cognito.send(
        new GetIdCommand({
          IdentityPoolId: config.identityPoolId,
          Logins: { [loginsKey]: currentIdToken! },
        }),
      );
      currentIdentityId = r.IdentityId ?? null;
      return currentIdentityId;
    })();
  }
  const id = await identityPromise;
  if (!id) throw new Error('Failed to obtain Cognito Identity Pool identity.');
  return id;
}

/**
 * Stable credential provider. The `logins` function is called fresh on every credential fetch,
 * so when the ID token rotates via OIDC silent renew the next AWS call picks it up automatically.
 */
export const awsCredentials = fromCognitoIdentityPool({
  clientConfig: { region: config.awsRegion },
  identityPoolId: config.identityPoolId,
  logins: {
    [loginsKey]: async () => {
      if (!currentIdToken) throw new Error('Not signed in.');
      return currentIdToken;
    },
  },
});
